import api from "./core";
import SessionService from "./session";

const basePath = "api/portal/DocumentGroups";

export default {
  async get(id) {
    const { data } = await api.get(`${basePath}/${id}`);
    return data;
  },
  async update(id, data) {
    const { data: result } = await api.patch(`${basePath}/${id}`, data);
    return result;
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(formId, clientId, eocId) {
    return api.post(`${basePath}/ByEoc/${formId}/${eocId}`);
  },
  async create(data) {
    const { data: result } = await api.put(`${basePath}`, data);
    return result;
  },
  render(documentGroupId) {
    return api.get(`${basePath}/RenderDocumentGroup/${documentGroupId}`);
  },
  viewUrl(id) {
    return `${api.defaults.baseURL}${basePath}/Download/${
      SessionService.session().token
    }/${id}`;
  },
  upload(sharedDocumentId, data) {
    const { file } = data;
    const formData = new FormData();
    if (file) formData.append("File", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return api.put(`${basePath}/Upload/${sharedDocumentId}`, formData, config);
  }
};
